const Getters = {
  getBalanceOfPaymentListFromState: (state) => {
    return state.balanceOfPaymentList
  }
}

export default Getters
